@if(label && (sentimentAnalysisService.enabled$ | async)) {
  <div [class]="isDismissible ? 'flex items-center gap-1 mt-2' : ''">
      @if (isDismissible) {
        <ui-icon
          icon="griddy-alert-triangle"
          class="text-smoke-darker"></ui-icon>
      }

      <ui-badge variant="primary" class="truncate" appearance="solid" size="sm" value="{{ label }}"></ui-badge>

      @if (isDismissible) {
        <ui-button variant="quaternary" size="sm" icon="griddy-close" (onClick)="dismiss.emit()"></ui-button>
      }
    </div>
}
